import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import SeoHead from "@/seo/SeoHead";

export default function NotFound({ pathname }) {
  return (
    <div id="top" className="grain min-h-screen bg-ink text-ivory">
      <SeoHead
        page={{ title: "Page Not Found | Asad Hatimi", description: "The requested page could not be found." }}
        pathname={pathname}
        noindex
      />
      <Nav />
      <main className="flex min-h-[75vh] items-center border-b border-surface-2">
        <div className="mx-auto w-full max-w-[1000px] px-6 py-40 md:px-16">
          <div className="text-[11px] uppercase tracking-[0.28em] text-brass">404 · Page not found</div>
          <h1 className="mt-6 font-serif-display text-6xl font-light text-ivory md:text-8xl">
            This page has moved<span className="text-brass italic">.</span>
          </h1>
          <p className="mt-8 max-w-xl text-lg font-light leading-relaxed text-mutedfg">
            Return to the main profile or explore the latest project-management insights.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <a href="/" className="bg-brass px-7 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-ink">
              Main profile
            </a>
            <a href="/insights/" className="border border-surface-2 px-7 py-4 text-xs uppercase tracking-[0.2em] text-ivory hover:border-brass">
              View insights
            </a>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
